export default __webpack_public_path__ + "static/media/Sahi.70b592ca.jpg";